var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPangolin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pangolin_clip_path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1739 0.00406061L15.479 0.00195312L16.2781 2.46592L11.2012 6.1487L15.2205 9.07235L19.9918 5.61099L18.1739 0.00406061Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.71047 2.45764L4.51077 0.00211073L1.82519 0L0 5.60481L4.76593 9.07251L8.79061 6.15307L3.71047 2.45764Z",
    fill: "#E1AA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53351 2.96981L5.45505 0.00292969L4.76758 2.11475L9.53351 5.58244L9.53561 5.58138V2.9677L9.53351 2.96981Z",
    fill: "#E1AA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5359 0.00585938L10.4521 2.96747V5.58115L15.2213 2.1219L14.5359 0.00585938Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.77706 10.1745L4.76758 10.2051L9.53351 13.6739L9.53561 13.6717V6.72266L4.77706 10.1745Z",
    fill: "#E1AA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2097 10.176L10.4574 6.71777L10.4521 6.72199V13.6711L15.2213 10.2118L15.2097 10.176Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53246 14.7834L5.65328 11.9609L4.76758 14.6811L9.53351 18.1488L9.53561 18.1467V14.7813L9.53246 14.7834Z",
    fill: "#E1AA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3377 11.9629L10.4521 14.7822V18.1476L15.2213 14.6883L14.3377 11.9629Z",
    fill: "#FFC800"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pangolin_clip_path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18.145,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPangolin);
export default __webpack_public_path__ + "static/media/pangolin.d8eb9aad.svg";
export { ForwardRef as ReactComponent };